import styled from 'styled-components';

export const TimerBase = styled.div`
  background: ${({ theme }) => theme.colors.neutral[0]};
  height: 64px;
  width: 128px;
  border: 1px solid ${({ theme }) => theme.colors.neutral[50]};
  border-radius: 5%;
  display: flex;
  justify-content: center;
  align-items: center;

  > h3 {
    color: ${({ theme }) => theme.colors.neutral[400]};
  }
`;
